import {
  GroupChannel,
  User,
  Member,
} from "@sendbird/chat/lib/__definition";
import { MemberWithMetaData } from "../types";
import {
  parsePeerDisplayNameFromChannelName,
  parsePeerUserIdFromChannelName,
} from "./parseChannelPeer";

const OPERATOR_ID = "627668";

function memberFromChannelName(
  channel: GroupChannel,
  currentUser: User
): MemberWithMetaData | null {
  const peerUserId = parsePeerUserIdFromChannelName(channel.name, currentUser.userId);
  if (!peerUserId) {
    return null;
  }

  const nickname =
    parsePeerDisplayNameFromChannelName(channel.name, currentUser.userId) || "";

  return { userId: peerUserId, nickname } as MemberWithMetaData;
}

export function getUserFromConversation(channel: GroupChannel, currentUser: User): MemberWithMetaData | null {
  const nonOperator = channel.members.find(
    (member) =>
      member.userId !== currentUser.userId &&
      member.role !== "operator" &&
      member.userId !== OPERATOR_ID
  );
  if (nonOperator) {
    return nonOperator as MemberWithMetaData;
  }

  // Fallback for channels where membership data is incomplete: show any non-current member.
  const anyOtherMember = channel.members.find(
    (member: Member) =>
      member.userId !== currentUser.userId && member.userId !== OPERATOR_ID
  );

  if (anyOtherMember) {
    return anyOtherMember as MemberWithMetaData;
  }

  return memberFromChannelName(channel, currentUser);
}